var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.468 17.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437",
    transform: "translate(7977.591 -3940.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_",
    transform: "translate(-7977.591 3941.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_907_",
    d: "M97.568,48.839H86.994A1.293,1.293,0,0,1,85.7,47.544V32.794A1.293,1.293,0,0,1,86.994,31.5H97.568a1.293,1.293,0,0,1,1.294,1.294v14.75A1.293,1.293,0,0,1,97.568,48.839Z",
    transform: "translate(-85.7 -31.5)",
    fill: "#c41e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_906_",
    d: "M98.8,59.66V45.282a.98.98,0,0,1,.982-.982h10.171a.98.98,0,0,1,.982.982V59.66a.98.98,0,0,1-.982.981H99.782A.985.985,0,0,1,98.8,59.66Z",
    transform: "translate(-98.288 -43.799)",
    fill: "#f45671"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    d: "M198.716,30.366V26.471L193.3,21.2h-4Z",
    transform: "translate(-8162.84 3919.695)",
    fill: "#e03258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_904_",
    d: "M189.3,21.2v.4h.415Z",
    transform: "translate(-8162.84 3919.695)",
    fill: "#8b1630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_903_",
    d: "M422.3,248v.3h.3Z",
    transform: "translate(-8386.729 3701.764)",
    fill: "#8b1630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M-2.9-1.055V0h-.494V-2.844h1.088A1.1,1.1,0,0,1-1.55-2.6a.835.835,0,0,1,.28.657.807.807,0,0,1-.274.651,1.153,1.153,0,0,1-.769.233Zm0-.4h.594a.585.585,0,0,0,.4-.124.456.456,0,0,0,.139-.358A.492.492,0,0,0-1.906-2.3a.542.542,0,0,0-.387-.142H-2.9ZM-.838,0V-2.844H0a1.317,1.317,0,0,1,.669.168,1.145,1.145,0,0,1,.452.477,1.513,1.513,0,0,1,.16.707v.143a1.506,1.506,0,0,1-.161.711,1.132,1.132,0,0,1-.459.473A1.378,1.378,0,0,1-.02,0Zm.494-2.445V-.395h.322a.742.742,0,0,0,.6-.243,1.059,1.059,0,0,0,.212-.7v-.158a1.087,1.087,0,0,0-.2-.707A.713.713,0,0,0,0-2.445Zm3.758,1.24H2.27V0H1.775V-2.844H3.582v.4H2.27V-1.6H3.414Z",
    transform: "translate(-7970.855 3955)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.292cc008b5420b58fef9a2a5e789287c.svg";
export { ForwardRef as ReactComponent };